import { handleActions } from 'redux-actions';
import { setCurrentPage, setTotalPages } from '../actions/pageInfo';
import PageInfo from '../../types/pageInfo';

const defaultState = {
  currentPage: 1,
  totalPages: 1,
};

export default handleActions<any, any>(
  {
    [setCurrentPage.toString()]: (
      state: PageInfo,
      action: ReturnType<typeof setCurrentPage>
    ) => ({
      ...state,
      currentPage: action.payload,
    }),
    [setTotalPages.toString()]: (
      state: PageInfo,
      action: ReturnType<typeof setTotalPages>
    ) => ({
      ...state,
      totalPages: action.payload,
    }),
  },
  defaultState
);
